import { COMPARISON_ID } from '@/consts/searchKeys';
import { useIsCompetitionAverageMode } from '@/hooks/useIsCompetitionAverageMode';
import { useQueryParam } from '@/hooks/useQueryParam';

// Whether any comparison — an entity or a competition average — is currently active.
export const useIsComparisonActive = () => {
  const comparisonIdParam = useQueryParam(COMPARISON_ID);
  const comparisonId = comparisonIdParam ? Number(comparisonIdParam) : null;
  const isCompetitionAverageMode = useIsCompetitionAverageMode();

  return !!comparisonId || isCompetitionAverageMode;
};
